module.exports = function(bootstrap) {
    bootstrap.run(["Service", "$q", "$http",
                      function (Service, $q, $httpProvider) {

                          new Service({
                                          name: 'emailGroupContracts',
                                          group:"eprsvc",
                                          url: "/eprsvc/x-services/secure/email/v1/icis/group-contracts",
                                          headers: {},
                                          getData: function() {
                                              this.headers['APPID'] = "EPRWEB";
                                              this.headers['clientHost'] = "hmhs.com";
                                              return this.post();
                                          }
                                      });
                      }]);
};
